import * as yup from "yup";

export const renewalsSearchSchema = yup.object().shape({
  search_type: yup.string().nullable(),
  search_criteria: yup.string().nullable(),
});
